package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import app.cash.sqldelight.coroutines.mapToOneOrNull
import com.tedd.db.Finance_account
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class FinanceAccountRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<Finance_account>> =
        db.financeAccountQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeById(id: String): Flow<Finance_account?> =
        db.financeAccountQueries.selectById(id).asFlow().mapToOneOrNull(Dispatchers.Default)

    suspend fun create(
        name: String,
        type: String,
        currency: String,
        balance: Long,
        icon: String,
        color: String,
        bank: String? = null,
        last4: String? = null,
        lowThreshold: Long? = null,
        highThreshold: Long? = null,
        orderIndex: Long = 0,
        id: String = newId("acc"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.financeAccountQueries.insert(id, name, type, currency, balance, icon, color, bank, last4, lowThreshold, highThreshold, orderIndex, now, now)
        id
    }

    suspend fun update(
        id: String,
        name: String,
        type: String,
        currency: String,
        icon: String,
        color: String,
        bank: String?,
        last4: String?,
        lowThreshold: Long?,
        highThreshold: Long?,
        orderIndex: Long,
    ) = withContext(Dispatchers.Default) {
        db.financeAccountQueries.update(name, type, currency, icon, color, bank, last4, lowThreshold, highThreshold, orderIndex, nowMillis(), id)
    }

    suspend fun setBalance(id: String, balance: Long) = withContext(Dispatchers.Default) {
        db.financeAccountQueries.updateBalance(balance, nowMillis(), id)
    }

    suspend fun adjustBalance(id: String, delta: Long) = withContext(Dispatchers.Default) {
        db.financeAccountQueries.adjustBalance(delta, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.financeAccountQueries.softDelete(now, now, id)
    }
}
